import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_2 = { class: "modal-contenido" }
const _hoisted_3 = { class: "formulario-inicial" }
const _hoisted_4 = { class: "formulario-opcion" }
const _hoisted_5 = ["for"]
const _hoisted_6 = ["id", "disabled"]
const _hoisted_7 = { class: "formulario-opcion" }
const _hoisted_8 = ["for"]
const _hoisted_9 = ["id", "disabled"]
const _hoisted_10 = { class: "formulario-opcion" }
const _hoisted_11 = ["for"]
const _hoisted_12 = ["id", "disabled"]
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 0,
  class: "formulario-opcion"
}
const _hoisted_15 = ["for"]
const _hoisted_16 = ["id", "disabled"]
const _hoisted_17 = { class: "botones" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]

import { ref, computed, watch } from 'vue'
import { ENFOQUES, type Enfoque } from '@/utils/enfoque'


export default /*@__PURE__*/_defineComponent({
  __name: 'FormularioComponente',
  props: {
    visible: { type: Boolean },
    modo: {},
    loading: { type: Boolean },
    nombrePadre: {},
    nombreComponente: {},
    nombreInicial: {},
    descripcionInicial: {},
    enfoqueInicial: {},
    grupoInicial: {},
    nombreNivelSiguiente: {}
  },
  emits: ["aceptar", "cancelar"],
  setup(__props: any, { emit: __emit }) {

/**
 * Formulario de alta y edición de un componente.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props

const emit = __emit

const nombre = ref('')
const descripcion = ref('')
const enfoque = ref<Enfoque>('general')
const grupoVariante = ref('')

// Cuando se abre el modal, inicializar los campos
watch(() => props.visible, (val) => {
  if (val) {
    nombre.value = props.nombreInicial ?? ''
    descripcion.value = props.descripcionInicial ?? ''
    enfoque.value = (props.enfoqueInicial as Enfoque) ?? 'general'
    grupoVariante.value = props.grupoInicial ?? ''
  }
})

const puedeAceptar = computed(() => !!nombre.value.trim())

const tituloModal = computed(() => {
  switch (props.modo) {
    case 'agregarNivel1': return `Agregar ${props.nombreNivelSiguiente ?? 'componente'}`
    case 'agregarHijo': return `Agregar ${props.nombreNivelSiguiente ?? 'componente'} a: ${props.nombrePadre ?? ''}`
    case 'modificar': return `Modificar componente: ${props.nombreComponente ?? ''}`
    default: return ''
  }
})

const textoBoton = computed(() => {
  if (props.loading) {
    return props.modo === 'modificar' ? 'Guardando…' : 'Creando…'
  }
  return 'Aceptar'
})

function emitirAceptar() {
  if (!puedeAceptar.value) return
  // El grupo solo aplica a variantes (enfoque específico); en General se limpia.
  const grupo = enfoque.value !== 'general' && grupoVariante.value.trim()
    ? grupoVariante.value.trim()
    : null
  emit('aceptar', {
    nombre: nombre.value.trim(),
    descripcion: descripcion.value?.trim() || '',
    enfoque: enfoque.value,
    grupo_variante: grupo
  })
}

return (_ctx: any,_cache: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", null, _toDisplayString(tituloModal.value), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", {
                for: 'nombre-' + _ctx.modo
              }, [
                _cache[5] || (_cache[5] = _createTextVNode(" Nombre ")),
                _createElementVNode("small", null, "(Nombre completo del " + _toDisplayString(_ctx.nombreNivelSiguiente ?? 'componente') + ")", 1)
              ], 8, _hoisted_5),
              _withDirectives(_createElementVNode("textarea", {
                id: 'nombre-' + _ctx.modo,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nombre).value = $event)),
                disabled: _ctx.loading,
                rows: "3",
                class: "nombre-textarea"
              }, null, 8, _hoisted_6), [
                [_vModelText, nombre.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", {
              for: 'descripcion-' + _ctx.modo
            }, _cache[6] || (_cache[6] = [
              _createTextVNode(" Descripción "),
              _createElementVNode("small", null, "(opcional)", -1)
            ]), 8, _hoisted_8),
            _withDirectives(_createElementVNode("textarea", {
              id: 'descripcion-' + _ctx.modo,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((descripcion).value = $event)),
              disabled: _ctx.loading
            }, null, 8, _hoisted_9), [
              [_vModelText, descripcion.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", {
              for: 'enfoque-' + _ctx.modo
            }, _cache[7] || (_cache[7] = [
              _createTextVNode(" Enfoque "),
              _createElementVNode("small", null, "(solo para aspectos que varían por tipo de programa)", -1)
            ]), 8, _hoisted_11),
            _withDirectives(_createElementVNode("select", {
              id: 'enfoque-' + _ctx.modo,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((enfoque).value = $event)),
              disabled: _ctx.loading
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ENFOQUES), (e) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: e.value,
                  value: e.value
                }, _toDisplayString(e.label), 9, _hoisted_13))
              }), 128))
            ], 8, _hoisted_12), [
              [_vModelSelect, enfoque.value]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("small", { class: "enfoque-nota" }, " “General” aplica siempre. Elige un enfoque específico para una variante. ", -1))
          ]),
          (enfoque.value !== 'general')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("label", {
                  for: 'grupo-' + _ctx.modo
                }, _cache[9] || (_cache[9] = [
                  _createTextVNode(" Grupo de peso compartido "),
                  _createElementVNode("small", null, "(mismo nombre = mismo peso)", -1)
                ]), 8, _hoisted_15),
                _withDirectives(_createElementVNode("input", {
                  id: 'grupo-' + _ctx.modo,
                  type: "text",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((grupoVariante).value = $event)),
                  disabled: _ctx.loading,
                  placeholder: "Ej: planta profesoral"
                }, null, 8, _hoisted_16), [
                  [_vModelText, grupoVariante.value]
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("small", { class: "enfoque-nota" }, [
                  _createTextVNode(" Pon el "),
                  _createElementVNode("strong", null, "mismo"),
                  _createTextVNode(" grupo en todas las variantes de un mismo aspecto: comparten un único slot de peso. Usa grupos distintos si hay dos aspectos que varían en la misma rama. ")
                ], -1))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              class: "btn salir",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('cancelar'))),
              disabled: _ctx.loading
            }, "Cancelar", 8, _hoisted_18),
            _createElementVNode("button", {
              class: "btn guardar",
              onClick: emitirAceptar,
              disabled: _ctx.loading || !puedeAceptar.value
            }, _toDisplayString(textoBoton.value), 9, _hoisted_19)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})